// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4252":"68f6077a","4978":"2a72d103","5154":"30765a8a","9341":"2a72d103"}[chunkId] + ".chunk.css";
};